import {register} from '../vendor/theme-scripts/theme-sections';
import accordions from '../features/accordion';
import scrollToElement from '../features/scroll-to-element';

register('sidebar', [accordions, scrollToElement]);
